<template>
    <div id="footer">
        <div class="footerContent">
            <div class="quickLink">
                <div class="item">快速入口：</div>
                <div class="item" @click="toLink('/knowledge')">景区概况</div>
                <div class="item" @click="toLink('/tutorialCenter')">旅游攻略</div>
                <div class="item" @click="toLink('/deploy')">景点推荐</div>
                <div class="item" @click="toLink('/case')">游客服务</div>
                <div class="item" @click="toLink('/download')">资讯动态</div>
            </div>
            <div class="copyRight">
                {{ copyRight }}
            </div>
            <!-- <div>
                陇ICP备 11000088号  甘公网安备 62098202000041号
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            copyRight: ''
        }
    },
    mounted() {
        this.getBeian();
    },
    methods: {
        getBeian() {
            this.$axios({
                url: `index/beian`,
                method: 'post',
            }).then(res => {
                this.copyRight = res.data.beian;
            })
        },
        toLink(path) {
            this.$router.push(path)
        }
    },
}
</script>

<style lang="scss" scoped>
#footer {
    width: 100%;
    height: 180px;
    position: relative;
    left: 0;
    bottom: 0;
    background: linear-gradient(90deg, #851C20 0%, #A6252C 100%);
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;

    .footerContent {
        width: fit-content;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .quickLink {
            margin-bottom: 36px;
            display: flex;

            .item {
                margin-right: 40px;
                cursor: pointer;

                &:first-child {
                    cursor: default;
                }
            }
        }

        .copyRight {
            margin-bottom: 20px;
        }
    }
}
</style>